import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Adminform from "./Adminform";
import AdminView from "./AdminView";
import Admintestimonials from "./Admintestimonials";
import AdmintestimonialsView from "./AdmintestimonialsView";
import FeaturedAdmin from "./FeaturedAdmin";
import FeaturedViewAdmin from "./FeaturedViewAdmin";
import Subcatgory from "./Subcatgory";
import Subcatgoryview from "./Subcatgoryview";
import AdminHeader from "./AdminHeader";
import AdminSidebar from "./AdminSidebar";

import Style from "../Style/AdminDashboard.module.scss";
import CourseMoreDisk from "./CourseMoreDisk";
import CourseMoreDiskView from "./CourseMoreDiskView";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("dashboard");
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const isAuth = localStorage.getItem("adminAuth");
    if (!isAuth) {
      navigate("/admin");
    }
  }, [navigate]);

  const renderActiveTab = () => {
    switch (activeTab) {
      case "add-image":
        return <Adminform />;
      case "view-image":
        return <AdminView />;
      case "add-testimonials":
        return <Admintestimonials />;
      case "add-testimonialsView":
        return <AdmintestimonialsView />;
      case "add Course":
        return <FeaturedAdmin />;
      case "add CourseView":
        return <FeaturedViewAdmin />;
      case "add-subcategory":
        return <Subcatgory />;
      case "add-subcategoryview":
        return <Subcatgoryview />;
      case "add-SubcategoryMore":
        return <CourseMoreDisk />;
      case "add-SubcategoryMoreView":
        return <CourseMoreDiskView />;
      default:
        return (
          <>
            <h1>Welcome to Admin Dashboard</h1>
            <p>Only visible after successful login.</p>
          </>
        );
    }
  };

  return (
    <div className={Style.dashboardContainer}>
      <AdminHeader toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />
      <div className={Style.dashboardContent}>
        <AdminSidebar
          isOpen={sidebarOpen}
          setActiveTab={setActiveTab}
          activeTab={activeTab}
        />
        <div
          className={`${Style.mainContent} ${
            sidebarOpen ? Style.shiftedContent : ""
          }`}
        >
          {renderActiveTab()}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
